import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';
import { PageComponentVideoLayoutData } from './video-layout.interface';

export default <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'video-layout',
    name: 'Video Layout',
    image: 'assets/images/cms/video-layout.png',
    tags: ['Homepage', 'Banner', 'Video'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link',
            title: 'Link on video and background image'
        },
        // video
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-video',
            title: 'Video'
        },
        {
            key: 'video_id',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL from Vimeo',
            default: ''
        },
        {
            key: 'video_background',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            default: true
        },
        {
            key: 'video_autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: true,
            canShow: (data: PageComponentVideoLayoutData) => !data?.video_background
        },
        {
            key: 'video_hide',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide',
            default: false
        },
        // background
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-background',
            title: 'Background'
        },
        {
            key: 'background_image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: undefined
        },
        // additional
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-additional',
            title: 'Additional'
        },
        {
            key: 'video_autoplay_in_view',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay In View',
            default: true,
            canShow: (data: PageComponentVideoLayoutData) => !data?.video_background && !data?.video_autoplay
        },
        {
            key: 'video_muted',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Muted',
            canShow: (data: PageComponentVideoLayoutData) => !data?.video_background
        },
        {
            key: 'video_loop',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Loop',
            default: true
        },
        {
            key: 'video_controls',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Controls',
            default: false,
            canShow: (data: PageComponentVideoLayoutData) => !data?.video_background
        },
        {
            key: 'video_progress_bar',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Progress Bar',
            default: true,
            canShow: (data: PageComponentVideoLayoutData) => data?.video_provider === 'vimeo'
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
